/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h3[_ngcontent-%COMP%]{margin:25px 0 0 -15px;padding:0 0 10px 15px;font-weight:600;color:#222;font-size:14px;text-transform:uppercase;letter-spacing:.1rem}h3[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}ul[_ngcontent-%COMP%]{list-style:none;margin:0 0 30px -15px;padding:0 0 0 15px}h3[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]{border-left:1px solid #eee}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:block;color:#222;font-size:13px;line-height:25px;text-transform:none;letter-spacing:.05rem}"];
export { styles as styles };
